import { configureStore } from "@reduxjs/toolkit";
import { profileReducer, setProfile } from "./slices/profileSlice";
import { routeReducer, setRoute } from "./slices/routeSlice";
import { reset } from "./actions";
const store = configureStore({
  reducer: {
    profile: profileReducer,
    route: routeReducer
  },
});

export { store, reset, setProfile, setRoute };
